(function($){
  $(document).ready(function() {


    $(".form-actions[data-sticky]").stickybits({
        useStickyClasses: true,
        verticalPosition: 'bottom'
    });

    $('[data-toggle="buttons"] input[type="radio"]').on('focus', function(){
        $(this).parent('label').toggleClass('focus');
    })

    $("body").on('change', ".fileinput", function(e){
        var $input   = $( this ),
            $label   = $input.next( '.filelabel' ),
            labelVal = $label.html();

        var fileName = '';
        if( e.target.value )
            fileName = e.target.value.split( '\\' ).pop();
        if( fileName ){
            $label.html( fileName );
        }
        else{
            $label.html( labelVal );
        }

        $input.on( 'focus', function(){ $input.addClass( 'has-focus' ); })
              .on( 'blur', function(){ $input.removeClass( 'has-focus' ); });
    });
  })
})(jQuery);
